module.exports = __webpack_public_path__ + "static/salivating.b6d17e4c.jpg";